<p-dialog [(visible)]="visivel" [style]="{width: '800px'}" header="Atendimento de remessa" [modal]="true" styleClass="p-fluid" (onHide)="escondeDialog()" (onShow)="onShow()">
    
    <ng-template pTemplate="content">
        <p-table
    [value]="remessa.itens"
    styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
    [resizableColumns]="true"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Insumo</th>
        <th>Descrição</th>
        <th>Quantidade</th>
        <th>Atendimento</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td>{{ item.cdMaterialPims }}</td>
        <td>{{ item.deMaterialPims }}</td>
        <td>{{ item.qtMovimento.toLocaleString("pt-BR", { minimumFractionDigits: 3, maximumFractionDigits: 3})  }} </td>
        <td><p-inputNumber mode="decimal" inputId="minmaxfraction" [minFractionDigits]="3" [maxFractionDigits]="3" [min]="0" [max]="item.qtMovimento || 0" [(ngModel)]="transferencias[item.cdMaterialPims].quantidade" /></td>
      </tr>
    </ng-template>
  </p-table>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="escondeDialog()"></button>
        <button pButton label="Atender" icon="pi pi-check" class="p-button-danger" (click)="confirmarAtendimento($event)"></button>
    </ng-template>
    <p-confirmDialog header="Confirmation" icon="fa fa-exclamation-triangle" width="425"></p-confirmDialog>
</p-dialog>